<template>
  <v-app-bar app dense dark absolute flat inset>
    <v-toolbar-title class="text-list">ระบบจัดการเอกสารโครงการ</v-toolbar-title>
    <v-spacer></v-spacer>
  </v-app-bar>
</template>

<script>
export default {
  name: "navbarBox",
  mounted() {
    let path = window.location.hash.split('#/')[1]
    if(path !== "" && this.$session.get("username") === undefined){
      this.$router.push("/")
    }
  }
};
</script>